<template>
  <div class="wrap talk re-style">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt">
						<h2>PASS 본인인증</h2>
					</section>
					<section class="form-section">
						<div class="box row row_c row_jsc">
							<h1>휴대폰 본인확인</h1>
							<p>본인 명의의 휴대폰을 사용하여<br>인증을 진행해 주세요</p>
						</div>
						<article class="box-bottom agree-wrap">
							<h4>서비스 동의</h4>
              <div class="chk-group agrm-form-input-area">
                <DxCheckBox
                  class="row_f wpAuto crtf-agree"
                  text="개인정보 수집 및 이용 동의"
                  v-model="chkAgrm1"
                />
                <span class="font-red weightM">(필수)</span>
                <a href="javascript:void(0);" @click.stop="detailPopup()">
                  <i class="ic-arrow-right"></i>
                </a>
              </div>
						</article>
            <CrtfPassTermsPopup/>
					</section>
					<div class="btn-wrap">
						<button class="talk-btn btn-black" :disabled="!chkAgrm1" @click.stop.prevent="certPass()">PASS 인증</button>
					</div>
				</article>
			</main>
		</div>
	</div>
</template>

<script>

import Vue from 'vue'
import AppConfig from '@/config'
import { DxCheckBox } from "devextreme-vue/check-box";
import CrtfPassTermsPopup from './CrtfPassTermsPopup.vue'

export default {
  name: 'CertPass',
  components: {DxCheckBox, CrtfPassTermsPopup},
  data: () => ({
    AppConfig: AppConfig,
    parms: {
      atmId : '',
      enCodePrncCrtfNum : '',
      passType: '',
      ord_number: '',
      agreeYn: false
    },
    chkAgrm1: false
  }),
  computed: {
  },
  mounted() {
    console.log(this.$route.params)
    console.log(this.$route.query)
    if(this.$route.query.passType && parseInt(this.$route.query.passType) >= 3) {
      console.log(this.$route.query.passType)
      console.log(this.$modal)
      this.$modal.show('nonfunctionalNoticePopup', {passType: this.$route.query.passType})
    }
  },
  methods: {

    async certPass () {
      // if(!this.chkAgrm1){
      //   Vue.Alert.alert("필수 약관에 동의해야<br>다음 단계로 진행할 수 있어요")
      //   return;
      // }

      const params = {
        prncCrtfNum : this.$route.query.enCodePrncCrtfNum ? this.$route.query.enCodePrncCrtfNum : this.$route.query.prncCrtfNum,
        atmId       : this.$route.query.atmId,
        passType    : this.$route.query.passType ? this.$route.query.passType : "",
        ord_number    : this.$route.query.ord_number ? this.$route.query.ord_number : "",
        thrdptyAgrmCd : this.parms.agreeYn == true ? '001' : ''
      }
      const rtn = await Vue.httpClient
        .get('/api/purchase/crtfNeo/public/crtfPassOvertime', {params})
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            if (res.data.result) {
              console.log(res.data.result)
              const rs = res.data.result;

              if(this.$route.query.passType)
                this.afterOthers(rs)
              else
              {
                // if(rs.certMinCheck == "CERT" && rs.prncCrtfCmplDt == "" && rs.clphNum == null) {
                if (rs.certMinCheck == "CERT" && (rs.prncCrtfCmplDt == null || rs.prncCrtfCmplDt == "")) {
                  this.formSubmit(rs)// 팝업 창
                } else if (rs.crtfConfYn == "Y") {
                  Vue.Alert.alert("이미 인증처리 되었습니다.")
                } else if (rs.certMinCheck == "CERT" && (rs.prncCrtfCmplDt != null && rs.prncCrtfCmplDt != "")) {
                  Vue.Alert.alert("본인인증이 완료되었습니다. " + rs.rdnmKey + "(을)를 ATM에 입력해 주세요.")
                } else if (rs.certMinCheck == "NOTCERT") {
                  Vue.Alert.alert("인증 유효 시간이 만기 되었습니다.(5분) ATM 에서 다시 시작해 주시기 바랍니다.")
                } else if (rs.clphNum != null) {   // 이 조건은 다시 확인 필요.
                  Vue.Alert.alert("ATM 에서 입력한 핸드폰 번호와 인증받으신 핸드폰 번호가 다릅니다. ATM 에서 다시 시작해 주시기 바랍니다.");
                } else {
                  Vue.Alert.alert("ATM 에서 다시 시작해 주시기 바랍니다.")
                }
              }
            }
          }
        })
    },
    afterOthers(rs) {
      // if(rs.certMinCheck == "CERT" && rs.prncCrtfCmplDt == "" && rs.clphNum == null) {
      if (rs.certMinCheck === "CERT" && !rs.prncCrtfCmplDt)
        this.formSubmit(rs);
      else if (rs.crtfConfYn === "Y")
        Vue.Alert.alert("이미 인증처리 되었습니다.")
      else if (rs.certMinCheck === "CERT" && rs.prncCrtfCmplDt)
        switch (this.$route.query.passType) {
          case "3":
            Vue.Alert.alert("이미 완료된 접수건입니다.")
            break;
          default:
            Vue.Alert.alert("이미 완료 되었습니다.")
            break;
        }
      else if (rs.certMinCheck === "NOTCERT")
        Vue.Alert.alert("인증 유효 시간이 만기 되었습니다.(5분) 처음부터 다시 시작 해 주세요.")
      else if (rs.clphNum != null)    // 이 조건은 다시 확인 필요.
        Vue.Alert.alert("처음 입력한 핸드폰 번호와 인증받으신 핸드폰 번호가 다릅니다. 처음부터 다시 시작 해 주세요.");
      else
        Vue.Alert.alert("처음부터 다시 진행 해 주세요.")

    },

    async certPassInit () {
      const params = {
        atmId : 'bos_test',
        prncCrtfNum : window.btoa('XADLAo0zndl4moDY1YzGmA=='),
        passType    : this.$route.query.passType ? this.$route.query.passType : ""
      }

      console.log('params ==> {}', params)

      const rtn = await Vue.httpClient
        .get('/api/purchase/crtf/public/niceCrtf', {params} )
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            if (res.data.result) {
              console.log(res.data.result)
            }
          } else {
            Vue.Alert.alert("통신 오류 입니다.")
          }
        })

    },
    formSubmit( rs ) {

        var mapForm = document.createElement("form");
          mapForm.id="mapForm";
          mapForm.target = "popupChk";
          mapForm.method = "POST"; // or "post" if appropriate
          mapForm.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
          //  mapForm.action = "http://localhost:9090/#/crtfpass/crtfPassPopup";

        var mapInput1 = document.createElement("input");
          mapInput1.type = "hidden";
          mapInput1.name = "m";
          mapInput1.value = "checkplusService";
          mapForm.appendChild(mapInput1);

        var mapInput2 = document.createElement("input");
          mapInput2.type = "hidden";
          mapInput2.name = "EncodeData";
          mapInput2.value = rs.encData;
          mapForm.appendChild(mapInput2);

        var mapInput3 = document.createElement("input");
          mapInput3.type = "hidden";
          mapInput3.name = "message";
          mapInput3.value = rs.erorMesgCtts;
          mapForm.appendChild(mapInput3);

        var mapInput4 = document.createElement("input");
          mapInput4.type = "hidden";
          mapInput4.name = "param_r1";   //
          mapInput4.value = rs.prncCrtfNum;
          mapForm.appendChild(mapInput4);

        var mapInput5 = document.createElement("input");
          mapInput5.type = "hidden";
          mapInput5.name = "param_r2";
          mapInput5.value = rs.rdnmKey;
          mapForm.appendChild(mapInput5);

          document.body.appendChild(mapForm);

        // var map = window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');

      // if (map) {
          // mapForm.submit();
          document.getElementById("mapForm").submit();
      // }

    },
    detailPopup () {
      this.$modal.show('crtfPassTermsPopup', {
        detailNum: 100
      })
    }
  }
}
</script>

<style scoped>
/deep/ .certification .crtf-agree .dx-checkbox-text {
  font-weight: inherit !important;
}
</style>


// WEBPACK FOOTER //
// src/views/crtfpass/CrtfPass.vue